<div 
    [@slideUpDown]="isVisible ? 'visible' : 'hidden'"
    class="route-details"
>
    <div class="route-details__header">
        <button (click)="onClickSwitchBtn(DirectionSwitch.Previous)" [disabled]="isLoadingRoute" class="route-details__header__btn left">
            <i *ngIf="!isLoadingRoute" class="pi pi-angle-left icon"></i>
            <ng-container *ngIf="isLoadingRoute">
                <ng-container *ngTemplateOutlet="loader"></ng-container>
            </ng-container>
        </button>
        <div class="route-details__header__content">
            <div class="route-details__header__content__header">
                <div class="route-details__header__content__header__left row">
                    <span class="car-name">
                        {{ vehicle?.Nm }}
                    </span>

                    <div 
                        [ngClass]="{ 'is-visible': driverData }"
                        class="driver"
                    >
                        <div class="driver__avatar">
                            {{ $any(driverData?.FN?.slice(0,1)) + $any(driverData?.LN?.slice(0,1)) }}
                        </div>
                        <span class="driver__name">
                            {{ driverData?.FN + ' ' + driverData?.LN }}
                        </span>
                    </div>
                </div>

                <!-- <div class="route-details__header__content__header__right row">
                    <button class="btn">
                        <img src="/assets/img/share-2-svgrepo-com.svg" alt="">
                    </button>
                    <button class="btn map-pin">
                        <img src="/assets/img/buttons/google/Primaryx3.png" alt="">
                    </button>
                    <button class="btn">
                        <img src="/assets/img/navigation-svgrepo-com.svg" alt="">
                    </button>
                </div> -->
            </div>

            <div class="route-details__header__content__route-lines">
                <app-route-line *ngIf="_routeData" [routeData]="_routeData"></app-route-line>
            </div>
        </div>
        <button (click)="onClickSwitchBtn(DirectionSwitch.Next)" [disabled]="isLoadingRoute" class="route-details__header__btn right">
            <i *ngIf="!isLoadingRoute" class="pi pi-angle-right icon"></i>
            <ng-container *ngIf="isLoadingRoute">
                <ng-container *ngTemplateOutlet="loader"></ng-container>
            </ng-container>
        </button>
    </div>
    <div class="route-details__footer">
        <app-route-summary-data [data]="routeSummary"></app-route-summary-data>
    </div>
</div>

<ng-template #loader>
    <p-progress-spinner 
        strokeWidth="2"
        fill="transparent"
        animationDuration=".5s"
        [style]="{ width: '15px', height: '15px' }"
    />
</ng-template>
